import * as Dialog from '@repo/ui/components/dialog';
import RichText from '@repo/ui/components/rich-text';
import { JSX, useRef, useState } from 'react';
import { HtmlString } from '../../types/html';

interface DialogSimple {
    title?: string;
    description?: HtmlString;
}

interface DialogSimpleProps extends DialogSimple {
    open: boolean;
    onClose: () => void;
    container: Element | null;
}

function DialogSimple({ title, description, open, onClose, container }: DialogSimpleProps): JSX.Element {
    return (
        <Dialog.Container open={open} onClose={onClose} container={container}>
            {title && (
                <Dialog.Title className="text-left">
                    <h2>{title}</h2>
                </Dialog.Title>
            )}

            {description && (
                <Dialog.Description className="text-left">
                    <RichText text={description} />
                </Dialog.Description>
            )}

            <Dialog.Close />
        </Dialog.Container>
    );
}

export function useSimpleDialog<ContainerType>(props: DialogSimple | undefined) {
    const includeDialog = Boolean(props?.title || props?.description);
    const [dialogOpened, setDialogOpened] = useState(false);
    const containerRef = useRef<ContainerType>(null);

    const closeDialog = () => setDialogOpened(false);
    const openDialog = () => setDialogOpened(true);

    return {
        includeDialog,
        dialogOpened,
        containerRef,
        closeDialog,
        openDialog,
    };
}

export default DialogSimple;
